import { BaseModel } from '@core/data-access';
import { ContentBuilderFieldType } from '../types/content-builder-field.type';
import { AttributeInsertExecutePayload, CkeditorPayload } from './ckeditor-payload.model';

export class FormFieldBase extends BaseModel {
  key: string;
  label: string;
  required: boolean;
  readonly: boolean;
  disable: boolean;
  order: number;
  controlType: string;
  fieldType: ContentBuilderFieldType;
  type: string;
  options!: string[];
  count?: number;
  config: any;

  constructor(
    options: {
      key?: string;
      label?: string;
      required?: boolean;
      readonly?: boolean;
      disable?: boolean;
      order?: number;
      controlType?: string;
      fieldType?: ContentBuilderFieldType;
      type?: string;
      count?: number;
      config?: any;
    } = {},
  ) {
    super();
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.readonly = !!options.readonly;
    this.disable = !!options.disable;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.fieldType = options.fieldType || 'dynamicField';
    this.type = options.type || '';
    this.config = options.config || {};
    this.count = typeof options.count === 'number' ? options.count : undefined;
  }

  getPlaceHolder(): string {
    return `<div class="fake-label">${this.label}</div>`;
  }

  getMarkerName(): string {
    return '';
  }

  getAttributePayloadForCk(): { attributeKey: string; value: string }[] {
    return [];
  }

  getCkAlias(keyName: string): string {
    return keyName;
  }

  getCommandPayloadToUpdateAttribute(data: any): AttributeInsertExecutePayload {
    return null as any;
  }
  getCommandPayloadToCreate(data: any): CkeditorPayload {
    return null as any;
  }
}
